// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductSettings_container__2Lk8G","closePanel":"ProductSettings_closePanel__23YcW","closeIcon":"ProductSettings_closeIcon__1DYDm"};